import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmDialogType, ConfirmDialogResult } from '../confirm-dialog.model';

@Component({
  selector: 'common-confirm',
  templateUrl: './confirm-popup.component.html',
  styleUrls: ['./confirm-popup.component.scss']
})
export class ConfirmComponent implements OnInit {
  public confirmDialogType = ConfirmDialogType;
  public confirmResult = ConfirmDialogResult;
  public dialogType: ConfirmDialogType;
  constructor(
    public dialogRef: MatDialogRef<ConfirmComponent>,
    // tslint:disable-next-line: no-any
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.dialogType = data.dialogType;
  }

  ngOnInit() {}

  onSelection(result: ConfirmDialogResult) {
    this.dialogRef.close(result);
  }
}
